import { render, staticRenderFns } from "./ButtonCreatePage.vue?vue&type=template&id=2158e64d&scoped=true&"
import script from "./ButtonCreatePage.vue?vue&type=script&lang=js&"
export * from "./ButtonCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCreatePage.vue?vue&type=style&index=0&id=2158e64d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158e64d",
  null
  
)

export default component.exports